'use strict';

module Patersons {

    export class DateSelectComponent implements ng.IComponentOptions {
        templateUrl: string = 'assets/templates/common/components/dateSelect.component.html';
        controller: any = DateSelectController;
        bindings: any = {
            isDisabled: '<',
            defaultDate: '<',
            date: '<',
            labelText: '@',
            onDateChange: '&'
        };
    }

    export class DateSelectController {
        isOpened: boolean = false;
        selectedDate: Date;
        defaultDate: Date;
        date: Date;
        format: string = "dd/MM/yyyy";
        onDateChange: any;

        constructor() {
            this.isOpened = false;
            this.format = "dd/MM/yyyy";

            if (this.defaultDate) {
                this.selectedDate = this.defaultDate;
            } else {
                if(this.date){
                    this.selectedDate = this.date;
                }else{
                    console.log(this.selectedDate)
                    this.selectedDate = new Date();
                }
            }
        }
        public $onChanges(changesObj) {
            if(changesObj.date && changesObj.date.currentValue){
                this.selectedDate = changesObj.date.currentValue;
            }
        }
        onDateSelect(e, data) {
            this.isOpened = false;
            this.onDateChange(data)
        }

        openCalendar() {
            this.isOpened = true;
        }
    }
}